import { render } from "./Navbar.vue?vue&type=template&id=8ada874c&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=8ada874c&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=8ada874c&scoped=true&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ada874c"]])

export default __exports__